import React from "react"
import cx from "classnames"
import styles from "./styles.module.scss"
import SingleColumn from "../content/single-column"
import SimpleTitle from "../simple-title"
import { MDXRenderer } from "gatsby-plugin-mdx"
import {kebabCase, startCase} from "lodash"
import { Link } from "gatsby"

const Content = ({body, frontmatter: {title, date, categories}}) => {
	return (
		<>
		<SimpleTitle title={title} />
		<SingleColumn>
			<p className={cx(styles.Categories)}>
        <strong>{date}</strong> // {categories.map((c, idx) => (
          <Link key={idx} to={`/blog/categories/${kebabCase(c)}`}>
            {startCase(c)}{idx < (categories.length - 1) ? ", " : null}
          </Link>
        ))}
      </p>
			<MDXRenderer>{body}</MDXRenderer>
			
		</SingleColumn>
		</>
	)
}

export default Content